export enum ModalState {
  OPENING = 'opening',
  OPENED = 'opened',
  CLOSING = 'closing',
  CLOSED = 'closed',
  HIDDEN = 'hidden',
  HIDING = 'hiding',
}

export enum ModalEvent {
  OPEN = 'open',
  CLOSE = 'close',
  HIDE = 'hide',
  SHOW = 'show',
}
